import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import DiscountHeader, {DiscountHeaderCircle} from "../../icons/DiscountHeader";
import {useEffect, useState} from "react";
import {InputError, notify, ProgressBar} from "../../utils";
import {canceledRequestDetail, canceledRequestPaid} from "../../../api/LeaderPortalApi";
import {positiveNotify} from "../../utils/Notify";

export default function DetailCanceledPopUp({open, setOpen, setLoadingPage, id, setId}) {
    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'517px'
    })

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState("")

    useEffect( () => {
        if(id) {
            canceledRequestDetail(id).then(response => {
                setData(response.data)
            }).catch(error => {
                notify(error?.response?.data?.message)
            })

        }
    }, [id])

    function onSubmit() {

        if(id) {
            setIsLoading(true)
            canceledRequestPaid(id).then(response => {
                setIsLoading(false)
                positiveNotify("با موفقیت انجام شد");
                setOpen(false)
                setLoadingPage(prev => !prev)
                setId("")
            }).catch(error => {
                setIsLoading(false)
                notify(error?.response?.data?.message)
            })

        }
    }


    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width p-0">
                <div className={`p-0 m-0 pb-5`} style={{position: "relative"}}>
                    <DiscountHeader />
                    <div className={`div_h_circle`}>
                        <DiscountHeaderCircle />
                    </div>
                </div>

                <p className={`text-center`}>
                    درخواست انصرافی {data?.traceId}
                </p>


                <div className='row mx-5 justify-content-center'>
                    <div className='col-12 border' style={{"borderRadius" : "10px"}}>

                        <p className='complete-info-text my-3'>اطلاعات هویتی تایید شده</p>
                        <div className='complete-info-text-row py-2'>
                            <span>کدملی</span>
                            <span style={{"color" : "#38BAC4"}}>{data?.nationalId}</span>
                        </div>

                        <div className='complete-info-text-row py-2'>
                            <span>شماره موبایل</span>
                            <span style={{"color" : "#38BAC4"}}>{data?.phoneNumber}</span>
                        </div>


                        <div className='complete-info-text-row py-2'>
                            <span>نام درخواست دهنده</span>
                            <span style={{"color" : "#38BAC4"}}>{data?.firstName} {data?.lastName}</span>
                        </div>

                        <div className='complete-info-text-row py-2'>
                            <span>نوع درخواست</span>
                            <span style={{"color" : "#38BAC4"}}>{data?.certType == "COMPANY" ? "حقوقی" : "حقیقی"}</span>
                        </div>

                        <div className='complete-info-text-row py-2 pb-3' style={{border: "none"}}>
                            <span>وضعیت درخواست</span>
                            <span style={{"color" : "#38BAC4"}}>{data?.status == "PAID_CANCEL" ? "تسویه شده" : "تسویه نشده"}</span>
                        </div>

                    </div>
                </div>

                <div className='row mx-5 mt-4 justify-content-center'>
                    <div className='col-12' style={{"borderRadius" : "10px", border: "1px solid #044448"}}>

                        <p className='complete-info-text my-3' style={{color: "#212121"}}>اطلاعات بانکی جهت عودت وجه</p>

                        <div className='canceled-row py-2'>
                            <span style={{fontWeight: "400", fontSize: "0.8rem"}}>شماره شبا</span>
                            <span>IR - {data?.shebaNumber}</span>
                        </div>

                        <div className='canceled-row py-2 pb-3'>
                            <span style={{fontWeight: "400", fontSize: "0.8rem"}}>شماره کارت</span>
                            <span>{data?.accountNumber}</span>
                        </div>

                    </div>
                </div>

                <div className='row mx-5 mt-4 justify-content-center'>
                    <div className='col-12' style={{"borderRadius" : "10px", border: "1px solid #044448"}}>

                        <p className='complete-info-text my-3 mb-2' style={{color: "#212121"}}>دلیل انصراف:</p>

                        <div className='canceled-row py-2' style={{textAlign: "justify"}}>
                            {data?.cancelReason}
                        </div>

                    </div>
                </div>

                <div className={`row mx-5 my-4 justify-content-between`}>
                    <button
                        className={`col-3 btn border p-0`}
                        style={{fontWeight: "600"}}
                        onClick={() => setOpen(false)}
                    >انصراف</button>
                    <button
                        className={`col-8 btn btn_discount py-2 p-0`}
                        onClick={onSubmit}
                        disabled={data?.status != "CANCEL"}
                    >
                        تسویه شد
                    </button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}